var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{domProps:{"textContent":_vm._s(_vm.item.label)}}),_c('span',{class:{'colFF7A45': _vm.item.colTrue},domProps:{"textContent":_vm._s(_vm.item.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }